import { RootState } from 'redux/store'

const selectFormsValidityState = (state: RootState) => state.formsValidity

const getFormValiditySelector = (formName = 'baseForm') => (state: RootState): boolean | undefined =>
  selectFormsValidityState(state).forms[formName]

export default getFormValiditySelector
